const global  = require('./global.js');

class Plotter
{
  constructor()
  {
    this.m_alldata=global.common.plotdata.alldata;
    this.m_origin=global.common.plotdata.origin;
    this.data=global.common.plotdata.data;
    this.datasets=global.common.plotdata.datasets;
    this.localstate=global.common.plotdata.localstate;

    if ( this.m_alldata.length===0 ) this.reset();
  }

  reset()
  {
    this.m_alldata=[];
    this.m_origin=[];
    this.data={};
    this.datasets=[];

    this.init(this.data);

    this.localstate={};

    global.common.plotdata.alldata=this.m_alldata;
    global.common.plotdata.origin=this.m_origin;
    global.common.plotdata.data=this.data;
    global.common.plotdata.datasets=this.datasets;
    global.common.plotdata.localstate=this.localstate;
  }


  init(data)
  {
    // User-defined configuration options
    data.sort = "on"
    data.xinit = "TIME"
    data.yinit = "FOPR"
    data.winit = ""
    data.ninit = ""
    data.points = "off"
    data.numisrept = "off"
    data.wellandrept = "off"
    data.chist = 0;
    data.bin = false;
    data.display = " ";

    // Other configuration options
    data.w = 1000;
    data.h = 500;
    data.legroomrt  = 450;
    data.legroombot = 200;
    data.margin = 60;

    data.lines = [];
    data.linecolours = ["red","blue","green","orange","black","yellow","purple","springgreen","turquoise","brown","salmon","goldenrod","orangered"];
    data.lastcol = 0;
    data.alldata = [];
    data.alllines = [];
    data.limits   = [-10000,-10000,-10000,-10000];

    data.modelcount = {};

    data.m_run={};

    data.leg_tl = false;
    data.leg_tr = false;
    data.leg_bl = false;
    data.leg_tr = false;

    data.baselayout = { height: 400, width: 1100, showlegend: true, 
                        margin: { l: 50, r: 50, t: 10 } ,
                       //legend: { x: 0, y: -500, xanchor:"left", yanchor:"bottom" },
                       xaxis: { title: 'X-axis Title', automargin: true, titlefont: {}, tickfont: {} },
                       yaxis: { title: 'Y-axis Title', automargin: true, titlefont: {}, tickfont: {}  }    };
    data.layout={};

  }

  initvecs(x,y)
  {
    this.data.xinit=x;
    this.data.yinit=y;
  }

  addline(alllines,orig,numx,numy,cblin,cbpt)
  {
    var line={};

    line.origin = orig;
    line.numx   = numx;
    line.numy   = numy;
    line.l      = 0;
    line.bline = cblin;
    line.bpts  = cbpt;

    line.colour = this.data.linecolours[this.data.lastcol];
    line.ptcolour = this.data.linecolours[this.data.lastcol];

    var lsame = -1;
    for (var jl=0; jl<alllines.length; ++jl)
    {
      if (alllines[jl].origin === orig &&
          alllines[jl].numx === numx && 
          alllines[jl].numy === numy) lsame = jl;
    }

    if ( lsame>=0 )
    {
      alllines[lsame].bline = cblin;
      alllines[lsame].bpts  = cbpt;
    }
    else
    {
      alllines.push(line);
    }
  }

  newplotorigin()
  {
    this.datasets = [];

    for ( var i=0; i<this.m_origin.length; i++ )
    {
      this.datasets.push(this.m_alldata[this.m_origin[i]]);
    }

    this.fillplotdropdowns();
  }

  fillplotdropdowns()
  {
    var mnems = [];

    // Property dropdowns
    for ( var id = 0; id<this.datasets.length; id++ )
    {
      var dataset = this.datasets[id];
      for ( var i = 0; i<dataset.mnem.length; i++ )
      {
        if ( mnems.indexOf(dataset.mnem[i])<0 ) mnems.push(dataset.mnem[i]);
      }
    }
    if ( this.data.sort==="on" ) mnems.sort();

    var xmnem_curr = "";
    var ymnem_curr = "";
    if (this.localstate.x.length>this.localstate.xs) xmnem_curr = this.localstate.x[this.localstate.xs];
    if (this.localstate.y.length>this.localstate.ys) ymnem_curr = this.localstate.y[this.localstate.ys];

    this.localstate.x = mnems; 
    this.localstate.y = mnems; 

    this.localstate.xs = mnems.indexOf(this.data.xinit);
    this.localstate.ys = mnems.indexOf(this.data.yinit);
    for ( i=0; i<mnems.length; ++i)
    {
      if (mnems[i] === xmnem_curr) this.localstate.xs = i;
      if (mnems[i] === ymnem_curr) this.localstate.ys = i;    
    }
    if (this.localstate.xs<0) this.localstate.xs = 0;
    if (this.localstate.ys<0) this.localstate.ys = 0;

    this.check_secondary_drops(this.localstate,true);
  }

  check_secondary_drops(state,force)
  {
    // Get details of the mnemonic to be plotted
    var xmnemdrop = state.x;
    var ymnemdrop = state.y;
    var xmnem = state.x[state.xs].toUpperCase();
    var ymnem = state.y[state.ys].toUpperCase();

    var qwx = xmnem.charAt(0)==="W";
    var qwy = ymnem.charAt(0)==="W";
    var qgx = xmnem.charAt(0)==="G";
    var qgy = ymnem.charAt(0)==="G";
    var qcx = xmnem.charAt(0)==="C";
    var qcy = ymnem.charAt(0)==="C";
    var qax = xmnem.charAt(0)==="A" && xmnem.length>1 && xmnem.charAt(1)==="A";
    var qay = ymnem.charAt(0)==="A" && ymnem.length>1 && ymnem.charAt(1)==="A";
    var qbx = xmnem.charAt(0)==="B" && xmnem.length>1;
    var qby = ymnem.charAt(0)==="B" && ymnem.length>1;
    var qlbx = xmnem.charAt(0)==="L" && xmnem.charAt(1)==="B" && xmnem.length>1;
    var qlby = ymnem.charAt(0)==="L" && ymnem.charAt(1)==="B" && ymnem.length>1;
    var qrx = (xmnem.charAt(0)==="R" && xmnem.length>1 && !xmnem.includes("_")) || this.localstate.yinit==="MSDEPTH";
    var qry = (ymnem.charAt(0)==="R" && ymnem.length>1 && !ymnem.includes("_")) || this.localstate.yinit==="MSDEPTH";

    // Exceptions (for MR output decks etc)
    if (xmnem==="CASE") qcx = false; if (ymnem==="CASE") qcy = false;
    if (xmnem.substr(0,3)==="RUN") qrx = false; if (ymnem.substr(0,3)==="RUN") qry = false;

    if (qwx !==xmnemdrop.qwold || force) this.fillwelldropdown("x", qwx, qgx, qcx);
    if (qwy !==ymnemdrop.qwold || force) this.fillwelldropdown("y", qwy, qgy, qcy);
    if (qgx !==xmnemdrop.qgold || force) this.fillwelldropdown("x", qwx, qgx, qcx);
    if (qgy !==ymnemdrop.qgold || force) this.fillwelldropdown("y", qwy, qgy, qcy);

    // If mnemonic is a completion set the appropriate well selection
    if ((qcx || xmnemdrop.qcold) && xmnem!==xmnemdrop.mnemold) this.fillwelldropdown("x", qwx, qgx, qcx);
    if ((qcy || ymnemdrop.qcold) && ymnem!==ymnemdrop.mnemold) this.fillwelldropdown("y", qwy, qgy, qcy);
    var xwell = state.xw[state.xws];
    var ywell = state.yw[state.yws];

    if (qbx !==xmnemdrop.qbold  ||
        qlbx!==xmnemdrop.qlbold ||
        qrx !==xmnemdrop.qrold  ||
        qcx !==xmnemdrop.qcold  ||
        qax !==xmnemdrop.qaold  ||
        xwell !== state.xw.wellold ||
        force) this.fillnumdropdown("x", qbx, qlbx, qrx, qcx, qax, xwell);
    if (qby !==ymnemdrop.qbold  ||
        qlby!==ymnemdrop.qlbold ||
        qry !==ymnemdrop.qrold  ||
        qcy !==ymnemdrop.qcold  ||
        qay !==ymnemdrop.qaold  ||
        ywell !== state.yw.wellold ||
        force) this.fillnumdropdown("y", qby, qlby, qry, qcy, qay, ywell);

    state.x.mnemold = xmnem;
    state.y.mnemold = ymnem;
    state.xw.wellold = xwell;
    state.yw.wellold = ywell;
    state.x.qwold  = qwx;
    state.y.qwold  = qwy;
    state.x.qgold  = qgx;
    state.y.qgold  = qgy;
    state.x.qbold  = qbx;
    state.y.qbold  = qby;
    state.x.qlbold = qlbx;
    state.y.qlbold = qlby;
    state.x.qrold  = qrx;
    state.y.qrold  = qry;
    state.x.qcold  = qcx;
    state.y.qcold  = qcy;
    state.x.qaold  = qax;
    state.y.qaold  = qay;
  }


  fillwelldropdown(type, qw, qg, qc)
  {
    // Well/Group dropdowns
    var wgs = [];
    if (qw || qg || qc)
    {
      for ( var is = 0; is<this.m_origin.length; is++ )
      {
        var id = this.m_origin[is];
        var dataset = this.m_alldata[id];
        for ( var i = 0; i<dataset.wg.length; i++ )
        {
          var qwi = dataset.mnem[i].toUpperCase()[0]==="W";
          var qgi = dataset.mnem[i].toUpperCase()[0]==="G";
          var qci = dataset.mnem[i].toUpperCase()[0]==="C";
          if ((qw && qwi) || (qg &&qgi) || (qc && qci))
          {
            if ( wgs.indexOf(dataset.wg[i])<0)
            {
              wgs.push(dataset.wg[i]);
            }
          }
        }
        if ( typeof dataset.wells != "undefined" )
        {
          for ( i=0; i<dataset.wells.length; i++ )
          {
            if ( wgs.indexOf(dataset.wells[i])<0 ) wgs.push(dataset.wells[i]);
          }
        }
      }
      if (this.data.sort==="on") wgs.sort();
    }
    else
    {
      wgs.push("");
    }

    if (type==="x")
    {
      var curr = "";
      if (this.localstate.xw>this.localstate.xws) curr = this.localstate.xw[this.localstate.xws];
      this.localstate.xw = wgs;
      this.localstate.xws = 0;
      for ( i=0; i<wgs.length; ++i )
      {
        if (wgs[i]===curr) this.localstate.xws = i;
      }
    }
    else if (type==="y")
    {
      curr = "";
      if (this.localstate.yw>this.localstate.yws) curr = this.localstate.yw[this.localstate.yws];
      this.localstate.yw = wgs;
      this.localstate.yws = 0;
      for ( i=0; i<wgs.length; ++i )
      {
        if (wgs[i]===curr) this.localstate.yws = i;
      }
    }
  }


  fillnumdropdown(type, qb, qlb, qr, qc, qa, selected_well)
  {
    var texts = [];

    for ( var id = 0; id<this.datasets.length; id++ )
    {
      var dataset = this.datasets[id];
      for ( var i = 0; i<dataset.num.length; i++ )
      {
        var text = this.numtext(dataset, i, qb, qlb, qr, qc, qa, selected_well);

        if ( texts.indexOf(text)<0 && text!=="") texts.push(text);
      }
    }
    if (texts.length===0) texts.push("");

    if (type==="x")
    {
      var curr = "";
      if (this.localstate.xn.length>this.localstate.xns) curr = this.localstate.xn[this.localstate.xns];
      this.localstate.xn = texts;
      this.localstate.xns = 0;
      for ( i=0; i<texts.length; ++i )
      {
        if (texts[i]===curr) this.localstate.xns = i;
      }
    }
    else if (type==="y")
    {
      curr = "";
      if (this.localstate.yn.length>this.localstate.yns) curr = this.localstate.yn[this.localstate.yns];
      this.localstate.yn = texts;
      this.localstate.yns = 0;
      for ( i=0; i<texts.length; ++i )
      {
        if (texts[i]===curr) this.localstate.yns = i;
      }
    }
  }

  // Calculate the text for the num dropdown
  numtext(dataset, i, qb, qlb, qr, qc, qa, selected_well)
  {
    var mnem = dataset.mnem[i].toUpperCase();
    var num  = dataset.num[i] + "";
    var text = "";

    if (this.data.chist===1 && mnem!=="ITER")
    {
      var ts = Math.floor(num/1000);
      var newt = num-ts*1000;
      text = "TS: " + ts + " Newt: " + newt;
    }
    else if (this.data.numisrept==="on") text = num;
    else if (this.data.wellandrept==="on") text = num;
    else if (qr && mnem[0]==="R") text = num;
    else if (qa && mnem[0]==="A") text = num;
    else if (qb && mnem[0]==="B") text = this.nat2ijk(dataset, num);
    else if (qc && mnem[0]==="C")
    {
      var well = dataset.wg[i].toUpperCase();
      if (well===selected_well.toUpperCase())
      {
        var comp = "";
        if (dataset.completions) comp = dataset.completions[i].toUpperCase();
        if (comp==="") text = this.nat2ijk(dataset, num);
        else text = comp;
      }
    }
    else if (qlb && mnem[0]==="L" && mnem[1]==="B")
    {
      var lgrs  = dataset.lgrs[i];
      var numlx = dataset.numlx[i];
      var numly = dataset.numly[i];
      var numlz = dataset.numlz[i];
      text = lgrs + ":(" + numlx + "," + numly + "," + numlz +")";
    }
    return text;
  }
    
  // Calculate (i,j,k) from a natural cell index (assuming no LGRs)
  nat2ijk(dataset, nat)
  {
    if (this.data.chist===1) return nat+"";
    if (this.data.numisrept==="on") return nat+"";
    if (this.data.wellandrept==="on") return nat+"";
    var num = nat-1;
    if (num<0) return "";

    var kk = Math.floor(num/(dataset.nx*dataset.ny))+1;
    num = num-(kk-1)*dataset.nx*dataset.ny;
    var jj = Math.floor(num/dataset.nx)+1;
    num = num-(jj-1)*dataset.nx;
    var ii = num+1;
    return "(" + ii + "," + jj + "," + kk + ")";
  }

  getlist(display)
  {
    this.data.display = display;
    document.getElementById("user").submit();  // then call getjobs from "frameload"...
  }

  getjobs(user,display)
  {
    var jsonFile = new XMLHttpRequest();
    jsonFile.open("GET",user+'/jobs.json',true);
    jsonFile.send();

    jsonFile.onreadystatechange = function() 
    {
      if (jsonFile.readyState=== 4 && jsonFile.status === 200) 
      {
        var jobs = JSON.parse(jsonFile.responseText);

        var element = document.getElementById("showresults");
        this.listresults(element,jobs,false);

        if( display==='runresults' )
        {
          var download = document.getElementById(display);
          this.listresults(download,jobs,true);
        }
      }
    }
  }

  listresults(element,jobs,download)
  {
    element.innerHTML='';

    var body='';

    if ( download ) 
    { 
      body += '<table>';
      body += '<tr><td><u>Job</u></td><td><u>Name</u></td><td><u>Complete</u></td><td><u>Summary</u></td></tr>';
    }

    for( var i=0; i<jobs.length; i++ )
    {
      if( jobs[i].completed )
      {
        if ( download ) 
        {
          body += '<tr><td>'+i+'</td><td>'+jobs[i].name+'</td><td>'+jobs[i].completed+'</td>';
          body += '<td><a href="'+this.data.m_run.m_user+'/'+jobs[i].name+'.js" download>'+jobs[i].name+'.js </a></td></tr>';
        }
        else
        {
          body += '<span id="'+jobs[i].name+'" onclick="getx(\''+this.data.m_run.m_user+'/'+jobs[i].name+'.js\')" style="color: #0000EE;"><u>'+jobs[i].name+'</u></span><br>';        
        }
      }
      else
      {
        if ( download ) 
        {
          body+='<tr><td>'+i+'</td><td>'+jobs[i].name+'</td><td>'+jobs[i].completed+'</td>';
        }
        else
        {
          body += jobs[i].name+'<br>';
        }
      }
    }
    element.insertAdjacentHTML('beforeend', body);
  }

  getx(name)
  {
    var jsonFile = new XMLHttpRequest();
    jsonFile.open("GET",name,true);
    jsonFile.send();

    jsonFile.onreadystatechange = function() 
    {
      if (jsonFile.readyState=== 4 && jsonFile.status === 200) 
      {
        var dataset=document.createElement('script');
        dataset.setAttribute("type","text/javascript");
        dataset.innerHTML = jsonFile.responseText;

        document.getElementsByTagName("head")[0].appendChild(dataset);
      }
    }
  }

  xclear()
  {
    for ( var i = this.data.alllines.length-1; i>=0; i-- )
    {
      this.data.alllines.pop();
     // this.data.lines.pop();
    }

    this.data.lastcol = 0;
  }

  clrange()
  {
    this.localstate.xmod = false;
    this.localstate.ymod = false;

    if ( !this.localstate.xfix )
    {
      this.localstate.xmin = "";
      this.localstate.xmax = "";
    }
    if ( !this.localstate.yfix )
    {
      this.localstate.ymin = "";
      this.localstate.ymax = "";
    }
      
    this.check_secondary_drops(this.localstate,false);
  }

  colour()
  {
    if ( this.data.alllines.length===0 ) return;
    this.data.lastcol++;
    if ( this.data.lastcol===this.data.linecolours.length ) this.data.lastcol=0;
    this.data.alllines[this.data.alllines.length-1].colour = this.data.linecolours[this.data.lastcol];
    this.data.alllines[this.data.alllines.length-1].ptcolour = this.data.linecolours[this.data.lastcol];
    this.clrange();
    this.actualplot();
    this.data.lastcol++;
    if ( this.data.lastcol===this.data.linecolours.length ) this.data.lastcol=0;
  }

  nlines()
  {
    return this.data.alllines.length;
  }

  layout()
  {
    return this.data.layout;
  }

  copyobj(objin)
  {
    var serial = JSON.stringify(objin);
    return JSON.parse(serial);
  }

  setuplines(state,data)
  {

    this.check_secondary_drops(state,false);

    // Get details of the mnemonic to be this.data.plotted
    var xmnem=state.x[state.xs].toUpperCase();
    var ymnem=state.y[state.ys].toUpperCase();
    var xwell=state.xw[state.xws].toUpperCase();
    var ywell=state.yw[state.yws].toUpperCase();
    var xnum=state.xn[state.xns].toUpperCase();
    var ynum=state.yn[state.yns].toUpperCase();
    var qwx = xmnem.charAt(0)==="W";
    var qgx = xmnem.charAt(0)==="G";
    var qcx = xmnem.charAt(0)==="C";
    var qwy = ymnem.charAt(0)==="W";
    var qgy = ymnem.charAt(0)==="G";
    var qcy = ymnem.charAt(0)==="C";
    var qax = xmnem.charAt(0)==="A" && xmnem.length>1 && xmnem.charAt(1)==="A";
    var qay = ymnem.charAt(0)==="A" && ymnem.length>1 && ymnem.charAt(1)==="A";
    var qbx = xmnem.charAt(0)==="B" && xmnem.length>1;
    var qby = ymnem.charAt(0)==="B" && ymnem.length>1;
    var qlbx = xmnem.charAt(0)==="L" && xmnem.charAt(1)==="B" && xmnem.length>1;
    var qlby = ymnem.charAt(0)==="L" && ymnem.charAt(1)==="B" && ymnem.length>1;
    var qrx = (xmnem.charAt(0)==="R" && xmnem.length>1) || data.yinit==="MSDEPTH";
    var qry = (ymnem.charAt(0)==="R" && ymnem.length>1) || data.yinit==="MSDEPTH";

    // Exceptions (for MR output decks etc)
    if (xmnem==="CASE") qcx = false; if (ymnem==="CASE") qcy = false;
    if (xmnem.substr(0,3)==="RUN") qrx = false; if (ymnem.substr(0,3)==="RUN") qry = false;

    // Loop over selected decks
    var foundx = false;
    var foundy = false;
    for ( var is=0; is<this.m_origin.length; is++ )
    {
      var i = this.m_origin[is]

      // Dataset is selected. Find mnemonic for x-axis
      var kx = -1;
      for ( var j = 0; j<this.m_alldata[i].mnem.length; j++ )
      {
	      if ( xmnem!==this.m_alldata[i].mnem[j] ) continue;

	      var numtextij = this.numtext(this.m_alldata[i], j, qbx, qlbx, qcx, qax, xwell).toUpperCase();
        if (data.chist===1)
        {
          if ( xnum==="" || xnum===numtextij)
          {
            kx = j;
            break;
          }
        }
        else if ( qwx || qgx )
        {
          if ( xwell===this.m_alldata[i].wg[j].toUpperCase()  )
          {
            kx = j;
            break;
          }
        }
        else if ( qcx )
        {
          if ( xwell===this.alldata[i].wg[j].toUpperCase() || xnum===numtextij )
          {
            kx = j;
            break;
          }
        }
        else if ( qrx || qax || qbx || qlbx )
        {
          if ( xnum===numtextij )
          {
            kx = j;
            break;
          }
        }
        else if ( data.wellandrept==="on" )
        {
          if ( xwell===this.m_alldata[i].wg[j].toUpperCase() && xnum===this.m_alldata[i].num[j] )
          {
            kx = j;
            break;
          }
        }
        else
        {
          kx = j;
          break;
        }
      }

      // Find mnemonic for y-axis
      var ky = -1;
      for ( j=0; j<this.m_alldata[i].mnem.length; j++ )
      {
        if ( ymnem!==this.m_alldata[i].mnem[j] ) continue;

        numtextij = this.numtext(this.m_alldata[i], j, qby, qlby, qry, qcy, qay, ywell).toUpperCase();

        if (this.data.chist===1)
        {
          if ( ynum==="" || ynum===numtextij )
          {
            ky = j;
            break;
          }
        }
        else if ( qwy || qgy )
        {
          if ( ywell===this.m_alldata[i].wg[j].toUpperCase() )
          {
            ky = j;
            break;
          }
        }
        else if ( qcy )
        {
          if ( ywell===this.m_alldata[i].wg[j].toUpperCase() && ynum===numtextij  )
          {
            ky = j;
            break;
          }
        }
        else if ( qry || qay || qby || qlby || data.numisrept==="on" )
        {
          if ( ynum===numtextij )
          {
            ky = j;
            break;
          }
        }
        else if ( data.wellandrept==="on" )
        {
          if ( ywell===this.m_alldata[i].wg[j].toUpperCase() && ynum===this.m_alldata[i].num[j] )
          {
            ky = j;
            break;
          }
        }
        else
        {
          ky = j;
          break;
        }
      }
	
      // Add line to be this.data.plotted if mnemonic has been found
      if ( kx >= 0 ) foundx = true;
      if ( ky >= 0 ) foundy = true;
      var cbl = 0;
      var cbp = 0;
      if ( state.qline   ) cbl = 1;
      if ( state.qpoints ) cbp = 1;
      if ( kx>=0 && ky>=0 ) this.addline(data.alllines,i,kx,ky,cbl,cbp);

      data.lastcol++;
      if ( data.lastcol===data.linecolours.length ) data.lastcol=0;
    }

    return foundx && foundy;
  }

  newplot(qplot)
  {
    if ( !qplot || this.localstate.x.length===0 ) return;

    var go = this.setuplines(this.localstate,this.data);

    var ret={};
    if ( go )
    {
      ret = this.actualplot();
    }

    return ret;
  }

  plotlyplot()
  {
    this.data.layout = this.copyobj(this.data.baselayout);

    var xmn = this.localstate.xmin;
    var xmx = this.localstate.xmax;
    var ymn = this.localstate.ymin;
    var ymx = this.localstate.ymax;

    //
    // Go plot
    //
    var xmind =  1.0e30;
    var xmaxd = -1.0e30;
    var ymind = new Array(this.data.alllines.length).fill(1.0e30);
    var ymaxd = new Array(this.data.alllines.length).fill(-1.0e30);
    var amind =  1.0e30;
    var amaxd = -1.0e30;

    var u0=this.m_alldata[this.data.alllines[0].origin].unit[this.data.alllines[0].numy];
    var nu=1;
    for ( var iline=1; iline<this.data.alllines.length; iline++ )
    {
      var jo  = this.data.alllines[iline].origin;
      var jjy = this.data.alllines[iline].numy;
      var ju  = this.m_alldata[jo].unit[jjy];

      if ( ju===u0 ) nu++;
    }

    for ( iline=0; iline<this.data.alllines.length; iline++ )
    {
      var origin = this.data.alllines[iline].origin;
      var jx     = this.data.alllines[iline].numx;
      var jy     = this.data.alllines[iline].numy;
      var datax  = this.m_alldata[origin].data[jx];
      var datay  = this.m_alldata[origin].data[jy];
      var unity  = this.m_alldata[origin].unit[jy];
      var area   = 0.0;

      for ( var i=0; i<datax.length; i++ )
      {
        if ((ymn==="" && ymx==="") || (datay[i]>=ymn && datay[i]<=ymx) || iline<this.data.alllines.length-1 )
        {
          if (datax[i]<xmind )  xmind = datax[i];
          if (datax[i]>xmaxd )  xmaxd = datax[i];
        }
        if ((xmn==="" && xmx==="") || (datax[i]>=xmn && datax[i]<=xmx) || iline<this.data.alllines.length-1 )
        {
          if (datay[i]<ymind[iline]  ) ymind[iline] = datay[i];
          if (datay[i]>ymaxd[iline]  ) ymaxd[iline] = datay[i];
        }
        if (i>0)
        {
          area += 0.5*(datax[i]-datax[i-1])*(datay[i]+datay[i-1]);
        }
      }
      if (area<amind )  amind = area;
      if (area>amaxd )  amaxd = area;

      //
      // Lines with the same units
      //
      for ( var jline=0; jline<iline; jline++ )
      {
        jo  = this.data.alllines[jline].origin;
        jjy = this.data.alllines[jline].numy;
        ju  = this.m_alldata[jo].unit[jjy];

        if ( ju===unity && !this.localstate.ymod )
        {
          var yminb = Math.min(ymind[iline],ymind[jline]);
          var ymaxb = Math.max(ymaxd[iline],ymaxd[jline]);
          ymind[iline] = yminb; ymind[jline] = yminb;
          ymaxd[iline] = ymaxb; ymaxd[jline] = ymaxb;
          if ( iline===this.data.alllines.length-1 && nu!==this.data.alllines.length ) { ymn = ""; ymx = ""; }
        }
      }
      if (ymind[iline]===ymaxd[iline]) ymaxd[iline] = ymind[iline]+1.0;
      if ( this.localstate.ymod || this.localstate.yfix )
      {
        ymind[iline] = parseFloat(this.localstate.yminf);
        ymaxd[iline] = parseFloat(this.localstate.ymaxf);
      }
      this.localstate.ymin = Math.min(this.localstate.ymin,ymind[iline]);
      this.localstate.ymax = Math.max(this.localstate.ymax,ymaxd[iline]);
    }

    if (xmind===xmaxd) xmaxd = xmind+1.0;

    if ( this.localstate.xmod || this.localstate.xfix )
    {
      xmind = this.localstate.xminf;
      xmaxd = this.localstate.xmaxf;
    } 
    this.localstate.xmin = xmind;
    this.localstate.xmax = xmaxd;

    // 
    // Plotly data structure
    //
    var plotlydata = [];

    var text = this.legend_text( this.localstate.qdetail );
    var nyaxis=1;

    for ( iline=0; iline<this.data.alllines.length; iline++ )
    {
      origin = this.data.alllines[iline].origin;
      jx     = this.data.alllines[iline].numx;
      jy     = this.data.alllines[iline].numy;
      datax  = this.m_alldata[origin].data[jx];
      datay  = this.m_alldata[origin].data[jy];
      var unitx  = this.m_alldata[origin].unit[jx];
      unity  = this.m_alldata[origin].unit[jy];

      var ttdata = { x: [], y: [], mode: 'lines', name: text[iline], line: { color: this.data.alllines[iline].colour } };

      this.data.layout.xaxis.title = unitx;
      if ( this.localstate.xlog ) this.data.layout.xaxis.type = 'log';

      var iyaxis=-1;
      for ( i=0; i<iline; i++ )
      {
        var orig = this.data.alllines[i].origin;
        var ky= this.data.alllines[i].numy;
        if ( this.m_alldata[orig].unit[ky]===unity ) 
        { 
          iyaxis = this.data.alllines[i].yaxis; 
          ttdata.yaxis = 'y'+iyaxis.toString();   
          break;
        }
      }
      if ( iyaxis<0 )
      {
        this.data.alllines[iline].yaxis = nyaxis;
        
        if ( nyaxis===1 ) 
        {
          this.data.layout.yaxis.title = unity;
          this.data.layout.yaxis.position = 0.0;
          this.data.layout.xaxis.domain = [0.01, 1.0];
          if ( this.localstate.ylog ) this.data.layout.yaxis.type = 'log';
        }
        else 
        { 
          var dy = 0.08*(nyaxis-1);
          var y = 'yaxis'+nyaxis.toString(); 
          this.data.layout[y] = { title: unity, 
                                  titlefont: { color: this.data.alllines[iline].colour },
                                  tickfont: { color: this.data.alllines[iline].colour },
                                  anchor: 'free',
                                  overlaying: 'y',
                                  side: 'left',
                                  position: dy};
          this.data.layout.xaxis.domain = [dy+0.01, 1.0];
          if ( nyaxis===2 ) 
          {
            this.data.layout.yaxis.titlefont = { color: this.data.alllines[iline-1].colour };
            this.data.layout.yaxis.tickfont = { color: this.data.alllines[iline-1].colour };
          }
        };
        
        if ( nyaxis>1 ) ttdata.yaxis = 'y'+nyaxis.toString();        
        nyaxis++;
      }

      if ( this.data.alllines[iline].bline===1 )
      { 
        if ( this.data.alllines[iline].bpts===1 )  ttdata.mode = 'lines+markers'; 
        else                                       ttdata.mode = 'lines';
      }
      else                                        
      { 
        if ( this.data.alllines[iline].bpts===1 )  ttdata.mode = 'markers'; 
        else                                       ttdata.mode = ''; // defaults to lines I think
      }

      for ( i=0; i<datax.length; i++ )
      {      
        if (datax[i]>=xmind && datax[i]<=xmaxd)
        {
          if (datay[i]>=ymind[iline] && datay[i]<=ymaxd[iline])
          {
            // Look for viewing box intersections with the previous point
            if (i>0)
            {
              var im = i-1;
              var m = 1.0e30;
              var minv = 1.0e30;
              if (Math.abs(datax[i]-datax[im])>1.0e-30) m = (datay[i]-datay[im])/(datax[i]-datax[im])
              if (Math.abs(m)>1.0e-30) minv = 1.0/m;
              if (datax[im]<xmind)
              {
                var yl = datay[i]+m*(xmind-datax[i]);
                this.tpush(ttdata, xmind, yl);
              }
              if (datax[im]>xmaxd)
              {
                var yr = datay[i]+m*(xmaxd-datax[i]);
                this.tpush(ttdata, xmaxd, yr);
              }
              if (datay[im]<ymind[iline])
              {
                var xb = datax[i]+minv*(ymind[iline]-datay[i]);
                this.tpush(ttdata, xb, ymind[iline]);
              }
              if (datay[im]>ymaxd[iline])
              {
                var xt = datax[i]+minv*(ymaxd[iline]-datay[i]);
                this.tpush(ttdata, xt, ymaxd[iline]);
              }
            }

            // Add current point
            this.tpush(ttdata, datax[i], datay[i]);

            // Look for viewing box intersections with the next point
            if (i<datax.length)
            {
              var ip = i+1;
              m = 1.0e30;
              minv = 1.0e30;
              if (Math.abs(datax[ip]-datax[i])>1.0e-30) m = (datay[ip]-datay[i])/(datax[ip]-datax[i])
              if (Math.abs(m)>1.0e-30) minv = 1.0/m;
              if (datax[ip]<xmind)
              {
                yl = datay[i]+m*(xmind-datax[i]);
                this.tpush(ttdata, xmind, yl);
              }
              if (datax[ip]>xmaxd)
              {
                yr = datay[i]+m*(xmaxd-datax[i]);
                this.tpush(ttdata, xmaxd, yr);
              }
              if (datay[ip]<ymind[iline])
              {
                xb = datax[i]+minv*(ymind[iline]-datay[i]);
                this.tpush(ttdata, xb, ymind[iline]);
              }
              if (datay[ip]>ymaxd[iline])
              {
                xt = datax[i]+ minv*(ymaxd[iline]-datay[i]);
                this.tpush(ttdata, xt, ymaxd[iline]);
              }
            }
          }
        }
      }

      plotlydata.push(ttdata);
    }

    return plotlydata;
  }


  getaxes(state)
  {
    if ( state.x.length===0 ) return;

    var data={ alllines: [], lastcol: 0, linecolours: [] };
    this.setuplines(state,data);

    //
    // Check axes
    //
    var xmind =  1.0e30;
    var xmaxd = -1.0e30;
    var ymind =  1.0e30;
    var ymaxd = -1.0e30;

    for ( var iline=0; iline<data.alllines.length; iline++ )
    {
      var origin = data.alllines[iline].origin;
      var jx     = data.alllines[iline].numx;
      var jy     = data.alllines[iline].numy;
      var datax  = this.m_alldata[origin].data[jx];
      var datay  = this.m_alldata[origin].data[jy];

      for ( var i=0; i<datax.length; i++ )
      {
        if (datax[i]<xmind )  xmind = datax[i];
        if (datax[i]>xmaxd )  xmaxd = datax[i];

        if (datay[i]<ymind  ) ymind = datay[i];
        if (datay[i]>ymaxd  ) ymaxd = datay[i];
      }
    }

    if (xmind===xmaxd) xmaxd = xmind+1.0;
    if (ymind===ymaxd) ymaxd = ymind+1.0;

    if ( !state.xmod && !state.xfix )
    {
      state.xmin = xmind;
      state.xmax = xmaxd;
    }
    if ( !state.ymod && !state.yfix )
    {
      state.ymin = ymind;
      state.ymax = ymaxd;
    }
    
    // Save the start date if available
    var dates = this.m_alldata[origin].dates;
    if (dates!==undefined)
    {
      state.startdate = new Date();
      this.setStartDate(state.startdate, dates[0]);
    }
  }

  tpush(data,x,y)
  {
    var state = this.localstate;
    if (state.qdate && state.startdate!==undefined) data.x.push(this.addToDate(state.startdate, x));
    else data.x.push(x);

    data.y.push(y);
  }

  actualplot()
  {
    global.common.plotdata.alldata=this.m_alldata;
    global.common.plotdata.origin=this.m_origin;
    global.common.plotdata.data=this.data;
    global.common.plotdata.datasets=this.datasets;
    global.common.plotdata.localstate=this.localstate;

    return this.plotlyplot();
  }

  legend_text(qdetail)
  {
    var text = []; // one line per line

    for ( var iline=0; iline<this.data.alllines.length; ++iline )
    {
      var origin = this.data.alllines[iline].origin;
      var numx = this.data.alllines[iline].numx;
      var numy = this.data.alllines[iline].numy;

      // Construct corresponding text
      var t = this.m_alldata[origin].mnem[numy];
      t += " vs " + this.m_alldata[origin].mnem[numx];
      var qwy = t.charAt(0)==="W";
      var qgy = t.charAt(0)==="G";
      var qcy = t.charAt(0)==="C";
      var qay = t.charAt(0)==="A";
      var qby = t.charAt(0)==="B";
      var qry = t.charAt(0)==="R";
      if ( qwy && this.m_alldata[origin].wg[numy]!=="" )
      {
        t += " for well "+this.m_alldata[origin].wg[numy];
      }
      else if ( qgy && this.m_alldata[origin].wg[numy]!=="" )
      {
        t += " for group "+this.m_alldata[origin].wg[numy];
      }
      else if ( qcy )
      {
        if ( this.m_alldata[origin].completions && this.m_alldata[origin].completions[numy]!=="" ) 
        {
          t += " for well  "+this.m_alldata[origin].wg[numy]+" completion "+this.m_alldata[origin].wg[numy];
        }
        else if ( this.m_alldata[origin].num[numy]!==0 )
        {
          t += " for well  "+this.m_alldata[origin].wg[numy]+" completion "+this.nat2ijk(this.m_alldata[origin], this.m_alldata[origin].num[numy]);
        }
      }
      else if ( qay && this.m_alldata[origin].num[numy]!=="" )
      {
        t += " for aquifer "+this.m_alldata[origin].num[numy];
      }
      else if ( qry && this.m_alldata[origin].num[numy]!=="" )
      {
        t += " for region "+this.m_alldata[origin].num[numy];
      }
      else if (qby && this.m_alldata[origin].num[numy]!==0)
      {
        t += " for block "+this.nat2ijk(this.m_alldata[origin], this.m_alldata[origin].num[numy]);
      }
      var name = this.m_alldata[origin].name;
      if ( name.search('/')>0 ) name = name.substring(name.lastIndexOf('/')+1);
      t += ": "+name;

      if ( this.m_alldata[origin].hostname!=="UNKNOWN" && qdetail )
      {
        t += " (" + this.m_alldata[origin].nproc + " " + this.m_alldata[origin].arch + " of ";
        t += this.m_alldata[origin].hostname + " at #" + this.m_alldata[origin].revision +")";
      }

      text.push(t);
    }

    return text;
  }

  replot()
  {
    this.xclear();
    this.clrange();
    this.plot();
  }

  handlesummaries(evt)
  {
    this.handleFileSelect(evt);
  }

  handleFileSelect(evt)
  {
    var files = evt.target.files; // FileList object

    // files is a FileList of File objects. List some properties.
    for ( var i=0; i<files.length; i++ )
    {
      var f = files[i];

      var reader = new FileReader();
      var doc = document.body;
      reader.onload = this.onload(evt,doc);

      reader.onerror = function(event)
      {
        this.alertx("File could not be read",true);
      }

      reader.readAsText(f);

    }
  }

  onload(event,doc)
  {
    var dataset=document.createElement('script');
    dataset.setAttribute("type","text/javascript");
    var contents = event.target.result;
    dataset.innerHTML = contents;

    doc.appendChild(dataset);
  }

  isElectron()
  {
    var userAgent = navigator.userAgent.toLowerCase();
    return userAgent.indexOf(' electron/') > -1;
  }
  
  setStartDate(d0, datestr)
  {
    if ( typeof datestr!=='undefined' )
    {
      var datearr = ["",""];
      if ( datestr.search("T")>0 ) datearr = datestr.split("T");
      else                         datearr = datestr.split(" ");
      var date0 = datearr[0];
      var time0 = datearr[1].substring(0,8);
      var date0arr = date0.split("-");
      var time0arr = time0.split(":");
      d0.setUTCFullYear(date0arr[0]);
      d0.setUTCMonth(date0arr[1]-1);
      d0.setUTCDate(date0arr[2]);
      d0.setUTCHours(time0arr[0]);
      d0.setUTCMinutes(time0arr[1]);
      d0.setUTCSeconds(time0arr[2]);
    }
  }

  addToDate(d0, ndays)
  {
    var date = new Date(d0);
    date.setTime(date.getTime()+24*60*60*1000*ndays);
    return date.toISOString();
  }

  alertx(message,qerror)
  {

    if ( this.isElectron() )
    {
      const { dialog } = window.require("electron").remote;
      const options =
      {
        title: 'Message',
        message: message
      };

      if (qerror) options.title = 'Error';

      dialog.showMessageBox(null, options);

    }
    else
    {
      if (qerror) alert("Error:"+message);
      else        alert(message);
    }
  }

}

export default Plotter
